import { render, staticRenderFns } from "./OrderUnits.vue?vue&type=template&id=144ea096&"
import script from "./OrderUnits.vue?vue&type=script&lang=js&"
export * from "./OrderUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports